import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';

import ContinueFooter from '../../components/ContinueFooter';

import './style.css';

class PersonalDetails extends Component {

  static propTypes = {
    onFinishDetails: PropTypes.func.isRequired,
  };

  state = {
    name: '',
    email: '',
    phoneNumber: '',
  };

  handleFinish = () => this.props.onFinishDetails(this.state);
  handleChange = (field) => (event) => this.setState({ [field]: event.target.value });

  isValid() {
    return (
      this.state.name.length > 3
      && this.state.email.length > 10
      && this.state.phoneNumber.length > 7
    );
  }

  render() {
    return (
      <div className="PersonalDetails">
        <TextField
          value={this.state.name}
          onChange={this.handleChange('name')}
          floatingLabelText="Full Name"
        />
        <TextField
          value={this.state.phoneNumber}
          onChange={this.handleChange('phoneNumber')}
          floatingLabelText="Phone Number"
        />
        <TextField
          value={this.state.email}
          onChange={this.handleChange('email')}
          floatingLabelText="E-Mail Address"
        />
        <ContinueFooter
          continueLabel="Begin Certification"
          disableContinue={!this.isValid()}
          onContinue={this.handleFinish}
        />
      </div>
    );
  }
}

export default PersonalDetails;


// WEBPACK FOOTER //
// ./src/containers/PersonalDetails/index.js